import { EventDispatcher, EventStream, Vector2 } from '@cgs/wge';
import { ComponentIndex } from '../../entities_engine/component_index';
import { EntitiesEngine } from '../../entities_engine/entities_engine';
import { Entity } from '../../entities_engine/entity';
import { ComponentNames } from '../../entity_components/component_names';
import { EntityCacheHolder } from '../../game_components/entity_cache_holder';
import { InternalReelsConfig } from '../../internal_reels_config';
import { BaseSystem } from '../../systems/base_system';

export class AfterAccelerationSystem extends BaseSystem {
  private readonly _indexesForFilter: ComponentIndex[];
  private readonly _relocatedFlagIndex: ComponentIndex;
  private readonly _positionIndex: ComponentIndex;
  private readonly _speedIndex: ComponentIndex;
  private readonly _reelsConfig: InternalReelsConfig;
  private readonly _acceleratedLineCount: number[];
  private readonly _reelIndex: ComponentIndex;
  private readonly _reelFalled: EventDispatcher<number> = new EventDispatcher();

  constructor(
    engine: EntitiesEngine,
    entityCacheHolder: EntityCacheHolder,
    reelsConfig: InternalReelsConfig,
    indexesForFilter: ComponentIndex[]
  ) {
    super(engine, entityCacheHolder);

    this._reelsConfig = reelsConfig;
    this._indexesForFilter = indexesForFilter;
    this._positionIndex = engine.getComponentIndex(ComponentNames.Position);
    this._reelIndex = engine.getComponentIndex(ComponentNames.ReelIndex);
    this._relocatedFlagIndex = engine.getComponentIndex(ComponentNames.RelocatedFlag);
    this._speedIndex = engine.getComponentIndex(ComponentNames.Speed);
    this._acceleratedLineCount = new Array<number>(reelsConfig.reelCount).fill(0);
  }

  public get reelFalled(): EventStream<number> {
    return this._reelFalled.eventStream;
  }

  public getIndexesForFilter(): ComponentIndex[] {
    return this._indexesForFilter;
  }

  public processEntity(entity: Entity): void {
    const relocated: number = entity.get(this._relocatedFlagIndex);

    if (relocated !== 0) {
      entity.set(this._speedIndex, Vector2.Zero);
      const position: Vector2 = entity.get<Vector2>(this._positionIndex);
      position.y = this._reelsConfig.offset.y - 2 * this._reelsConfig.symbolSize.y;
      entity.set(this._positionIndex, position);
      entity.removeComponent(ComponentNames.AccelerationInterpolate);
      this.fireEventIfNeed(entity);
    }
  }

  private fireEventIfNeed(entity: Entity): void {
    const reel: number = entity.get<number>(this._reelIndex);
    if (++this._acceleratedLineCount[reel] >= this._reelsConfig.lineCount) {
      this._acceleratedLineCount[reel] = 0;
      this._reelFalled.dispatchEvent(reel);
    }
  }
}
